import { SwitchFormField } from '@/components/form'
import { Flex } from '@/components/ui/flex'
import { Label } from '@/components/ui/label'

interface SwitchRowProps {
  label: string
  name: string
}

// Note: the label first, then the switch, both at the right edge of the form
export const SwitchRow = ({ label, name }: SwitchRowProps) => (
  <Flex align="center" gap={12} justify="flex-end">
    <Label htmlFor={name} size="medium">
      {label}
    </Label>
    <SwitchFormField name={name} />
  </Flex>
)
